var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDropdown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M24 28.959l11.81-10.334a2.526 2.526 0 113.327 3.803L25.664 34.217a2.526 2.526 0 01-3.328 0L8.863 22.427a2.526 2.526 0 013.327-3.802L24 28.96z",
    id: "dropdown_svg__a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "dropdown_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dropdown_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#dropdown_svg__a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#dropdown_svg__b)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h48v48H0z"
  })))));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+PGRlZnM+PHBhdGggZD0iTTI0IDI4Ljk1OWwxMS44MS0xMC4zMzRhMi41MjYgMi41MjYgMCAxIDEgMy4zMjcgMy44MDNMMjUuNjY0IDM0LjIxN2EyLjUyNiAyLjUyNiAwIDAgMS0zLjMyOCAwTDguODYzIDIyLjQyN2EyLjUyNiAyLjUyNiAwIDAgMSAzLjMyNy0zLjgwMkwyNCAyOC45NnoiIGlkPSJhIi8+PC9kZWZzPjxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+PG1hc2sgaWQ9ImIiIGZpbGw9IiNmZmYiPjx1c2UgeGxpbms6aHJlZj0iI2EiLz48L21hc2s+PHVzZSBmaWxsPSJjdXJyZW50Q29sb3IiIGZpbGwtcnVsZT0ibm9uemVybyIgeGxpbms6aHJlZj0iI2EiLz48ZyBtYXNrPSJ1cmwoI2IpIiBmaWxsPSJjdXJyZW50Q29sb3IiPjxwYXRoIGQ9Ik0wIDBoNDh2NDhIMHoiLz48L2c+PC9nPjwvc3ZnPg==";
export { SvgDropdown as ReactComponent };